import { IPublicClientApplication, AccountInfo } from '@azure/msal-browser';
import { tokenService } from './tokenService';
import { isJwtExpiringSoon } from './authHelper';

export const createAuthenticatedFetch = (
    msalInstance: IPublicClientApplication,
    account: AccountInfo
) => {
    return async (url: string, options: RequestInit = {}): Promise<Response> => {
        let token = tokenService.getCachedToken();
        
        if (!token || isJwtExpiringSoon(token, 5)) {
            token = await tokenService.getValidToken(msalInstance, account);
        }
        
        if (!token) {
            throw new Error('Failed to acquire authentication token');
        }
        
        return fetch(url, {
            ...options,
            headers: {
                ...options.headers,
                'Authorization': `Bearer ${token}`,
            },
        });
    };
};

export const fetchWithAuth = async (
    url: string,
    options: RequestInit = {}
): Promise<Response> => {
    const token = tokenService.getCachedToken();
    
    if (!token) {
        throw new Error('No authentication token available');
    }
    
    return fetch(url, {
        ...options,
        headers: {
            ...options.headers,
            'Authorization': `Bearer ${token}`,
        },
    });
};
